
import { Component } from '@angular/core'


@Component({
  selector: 'se-po-persona-avatar-docs',
  templateUrl: './persona-avatar-docs.component.html',
  styleUrls: ['./persona-avatar-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public avatarComponent: any = [
    {
      Property: '@Input() avatarDataSize',
      Type: 'string',
      Description: '(Optional) Customize se-fe-avatar size (300 by default)',
    },
    {
      Property: '@Input() headerDataSize',
      Type: 'string',
      Description: '(Optional) Customize se-fe-header size (500 by default)',
    },
    {
      Property: '@Input() headerLink',
      Type: 'string',
      Description: '(Optional) Defines a link on the header title',
    },
    {
      Property: '@Input() headerSubtitle',
      Type: 'string | string[]',
      Description: '(Optional) Customize the header subtitle',
    },
    {
      Property: '@Input() subtitleLink',
      Type: 'string',
      Description: '(Optional) Defines a link on the header subtitle',
    },
    {
      Property: '@Input() showGraduation',
      Type: 'boolean',
      Description: '(Optional) Include graduation date in default subtitle',
    },
    {
      Property: '@Input() persona',
      Type: 'Persona | OrgPersona',
      Description: 'Persona to display',
    },
    {
      Property: 'personaAvatarActions',
      Type: 'selector',
      Description: '(Optional) Actions content projected to the right',
    }
  ]
}
